export const RightArrow = ({ className, handleClick }) => {
  return (
    <svg
      width="11"
      height="19"
      viewBox="0 0 11 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      onClick={handleClick}
    >
      <path
        d="M1 18.25L9.75 9.5L0.999997 0.750002"
        stroke={className ? '' : '#070707'}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const LeftArrow = ({ className, onClick }) => {
  return (
    <svg
      onClick={onClick}
      width="11"
      height="19"
      viewBox="0 0 11 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M10 18.25L1.25 9.5L10 0.750002"
        stroke={className ? '' : '#070707'}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
